import { render, staticRenderFns } from "./AgenceForm.vue?vue&type=template&id=b19d247a&"
import script from "./AgenceForm.vue?vue&type=script&lang=js&"
export * from "./AgenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports